<template>
  <fh-container>
    <v-container class="fill-height" >
      <v-row align="center">
        <v-col cols="12" sm="6" class="text-center display-4">
          <h2>404</h2>
        </v-col>

        <v-col cols="12" sm="6" class="text-center text-sm-left">
          <v-card-text>
            <h1>Página no encontrada</h1>
          </v-card-text>

          <v-card-text>
            Lo sentimos, pero la página que busca no existe o no se puede encontrar.
          </v-card-text>

          <v-card-text>
            <v-btn @click="handleClick" color="primary">
              Volver al inicio
            </v-btn>
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>
  </fh-container>
</template>

<script>
import FhContainer from '@/components/FhContainer'
import { mapGetters } from 'vuex'

export default {
  name: 'NotFound',
  components: { FhContainer },
  computed: {
    ...mapGetters('auth', [
      'isLoggedIn'
    ])
  },
  methods: {
    handleClick () {
      if (this.isLoggedIn) {
        this.$router.push({ name: 'Home' })
      } else {
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
</script>

<style scoped>
  /* Left-align button with text */
  .v-btn >>> {
    margin: 0;
  }
</style>
